// extracted by mini-css-extract-plugin
export var fadeIn = "_cp-1";
export var modalContent = "_cp-3";
export var overlay = "_cp-0";
export var popoverContent = "_cp-2";
export var results = "_cp-5";
export var searchInputWrapper = "_cp-4";